/**
 * Created by wuhuping on 2017/7/4.
 */
import Instance from './resource'
export default {
  // 贷款产品列表
  fetchLoanProductList(data) {
    return Instance.post('prod/prodIndexInfo', data);
  },
  // 贷款产品详情
  fetchLoanProductDetail(data) {
    return Instance.post('prod/prodDetailInfo', data);
  },
  // 获取产品url
  fetchProductUrl(data) {
    return Instance.post('prod/getVisitUrl', data);
  },
  // 获取招联大额产品列表
  fetchZLProductList(data) {
    return Instance.post('prod/prodPositionList', data);
  },
  // 获取众安点点申请步骤
  fetchDotdotStepInfo(data) {
    return Instance.post('zaddProd/getStepInfo', data);
  },
  // 获取众安点点用户回显信息
  fetchDotdotUserInfo(data) {
    return Instance.post('zaddProd/getUserInfo', data);
  },
  // 保存众安点点用户信息
  saveDotdotUserInfo(data) {
    return Instance.post('zaddProd/saveZADDUserInfo', data);
  },
  // 上传数据到众安点点
  uploadUserInfoToDotdot(data) {
    return Instance.post('zaddProd/putZADDPostData', data);
  },
  // 众安点点清除用户信息
  clearDotdotUserInfo(data) {
    return Instance.post('zaddProd/changeOrderFail', data);
  },
  // 众安点点检查用户通讯录是否已经上传
  checkDotdotHasUploadedContacts(data) {
    return Instance.post('user/getCheckMailList', data);
  },
  // 众安点点上传用户通讯录
  uploadDotdotContacts(data) {
    return Instance.post('user/getCreateMailList', data);
  },
  // 检查是否是黑名单用户
  checkIsDotdotBlackListUser(data) {
    return Instance.post('zaddProd/checkAbility4ApplyZADD', data);
  }
}



// WEBPACK FOOTER //
// ./src/api/loan.js